import ActionBar from './ActionBar'
import {connect} from 'react-redux'
import {
  pageRequest,
  showTransactionDetailRequestNonMobile,
  showTransactionDetailRequestMobile,
  hideTransactionDetail,
  sendEmailReceipt
} from 'actions/reports/transactions'
import Summary from 'components/receipt/transactions/Summary'
import Table from './Table'
import TransactionDetail from 'components/receipt/transactions/TransactionDetail'
import ResendEmailModal from 'components/receipt/transactions/ResendEmailModal'
import TransactionRefundModal from 'components/receipt/refunds/TransactionRefundModal'
import TransactionDetailModal from 'components/receipt/transactions/TransactionDetailModal'
import OldRefundTransactionModal from 'components/receipt/refunds/OldRefundTransactionModal'
import './style.css'
import styles from './Transaction.css'
import {formValueSelector} from 'redux-form'
import NoDataAndLoading from 'components/NoDataAndLoading'
import {browserHistory} from 'react-router'

class Transaction extends React.Component {
  componentDidMount () {
    const {expired} = this.props.data.subscriptionExpired
    if (!expired) {
      this.props.dispatch(pageRequest())
    } else {
      browserHistory.push('/settings/billing')
    }
  }

  render () {
    // transactions == the reducer state. not to be confused with transactions.transactions
    let {transactions, transactionDetail, netSales, totalCollected, totalTransactions} = this.props.data.reports.transactions
    let {showLoadingSpinnerPage} = this.props.data.loadingSpinner

    return (
      <div className='transaction-list'>
        <div className='box-transaction-list'>
          <ActionBar />
          <div className={styles['report-transaction']}>
            <div style={{'height': '100%'}}>
              <div className={`col-sm-12 col-md-12 no-padding ${styles['left-column']}`} id='mk-col-left'>
                <NoDataAndLoading
                  showLoadingSpinner={showLoadingSpinnerPage}
                  noDataToDisplay={transactions && transactions.length === 0}
                  title='No Transactions'
                  description='You can make transactions through your device, or select different time frame.'
                  linkLabel='View and Download Your Customer Information and Transaction History'
                  linkUrl='https://mokaposhelp.zendesk.com/hc/en-us/articles/115005342787-View-and-Download-Your-Customer-Information-and-Transaction-History' />
                {transactions && transactions.length > 0 &&
                <div className={styles['transaction-wrapper']}>
                  <Summary
                    netSales={netSales}
                    totalCollected={totalCollected}
                    totalTransactions={totalTransactions}
                  />
                  {/* -- there are 2 table, with different action when onChangePayment is clicked-- */}
                  <div className={`visible-md visible-lg ${styles['table-wrapper']}`}>
                    <Table onChangePayment={this._onChangePaymentNonMobile} className='table-dekstop' />
                  </div>
                  <div className={`visible-xs visible-sm full-height`}>
                    <Table onChangePayment={this._onChangePaymentMobile} onClose={this._onClickDoneButton} className='table-mobile' />
                  </div>
                </div>
              }
              </div>
              {transactions && transactions.length > 0 &&
              <div className={`col-sm-12 ${styles['right-column']}`} id='mk-col-right'>
                <TransactionDetail
                  onClickDoneButton={this._onClickDoneButton}
                  dispatch={this.props.dispatch}
                  />
              </div>}
            </div>
          </div>

        </div>
        <ResendEmailModal dispatch={this.props.dispatch} onSubmit={this._onSubmitResendEmailForm} />
        {transactionDetail !== null && <TransactionRefundModal />}
        <TransactionDetailModal dispatch={this.props.dispatch} />
        {transactionDetail !== null && <OldRefundTransactionModal />}
      </div>)
  }

  _onChangePaymentNonMobile = (payment) => {
    this.props.dispatch(showTransactionDetailRequestNonMobile(payment.parent_payment_id, {}))
  };

  _onChangePaymentMobile = (payment) => {
    this.props.dispatch(showTransactionDetailRequestMobile(payment.parent_payment_id, {}))
  };

  _onClickDoneButton = () => {
    this.props.dispatch(hideTransactionDetail())
  };

  _onSubmitResendEmailForm = (values) => {
    let {transactionDetail} = this.props.data.reports.transactions
    let data = {
      customer_email: values.email,
      payment_id: transactionDetail.id,
      resend_email: true
    }
    this.props.dispatch(sendEmailReceipt(data))
  };
}

const selector = formValueSelector('search')

function mapStateToProps (state) {
  // only fetch some state
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date'),
      keyword: selector(state, 'keyword')
    },
    data: {
      reports: {
        transactions: state.reports.transactions
      },
      loadingSpinner: state.loadingSpinner,
      subscriptionExpired: state.subscriptionExpired
    }
  }
}

export default connect(mapStateToProps)(Transaction)



// WEBPACK FOOTER //
// ./app/pages/Reports/Transaction/Transaction.js